import { render, staticRenderFns } from "./TextAutoComplete.vue?vue&type=template&id=4c81aea2&scoped=true&"
import script from "./TextAutoComplete.vue?vue&type=script&lang=js&"
export * from "./TextAutoComplete.vue?vue&type=script&lang=js&"
import style0 from "./TextAutoComplete.vue?vue&type=style&index=0&id=4c81aea2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c81aea2",
  null
  
)

export default component.exports